module.exports = __webpack_public_path__ + "static/media/trace-bot-soccer-knee.2a46e8ca.svg";